var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-picker',{ref:"picker",attrs:{"show-toolbar":"","columns":_vm.columns},on:{"change":_vm.change,"cancel":function($event){return _vm.handleCancelAddress()},"confirm":function($event){return _vm.submitAddress()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }